import { ReactComponent as IconCloseBlue } from './img/iconCloseBlue.svg';
import styles from './ContractsMobileFilterItem.module.scss';

interface ContractsMobileFilterItemProps {
  label: string;
  active?: boolean;
  onRemove?: () => void;
  onClick?: () => void;
}

export const ContractsMobileFilterItem: React.FC<ContractsMobileFilterItemProps> = ({
  label,
  active = false,
  onRemove,
  onClick,
}) => {
  const handleClick = () => {
    if (onClick && !active) {
      onClick();
    }
  };

  return (
    <div
      className={active ? styles.filterItemActive : styles.filterItem}
      onClick={handleClick}>
      <span className={styles.filterItemLabel}>{label}</span>
      {active && onRemove && (
        <IconCloseBlue
          onClick={(e: React.MouseEvent) => {
            e.stopPropagation();
            onRemove();
          }}
        />
      )}
    </div>
  );
};
